export default __webpack_public_path__ + "static/media/wm7.954f418e.jpg";